export default __webpack_public_path__ + "static/media/organizations.cc3cbce8.png";